/**
 * Created by anthony on 6/21/14.
 */
var familyThresholds = angular.module('familyThresholds', []);
familyThresholds.service('FamilyThresholdsService', function(ApplicationService, AbstractModelService){
    return {
        put: function(data)
        {
            return AbstractModelService.put("/api/family/" + data.familyID + '/familyThresholds/' + ApplicationService.getAwardData().app[0].applicationID, data);
        },
        putHelper: function (data, putData, callback)
        {
            putData.familyID = data.familyID;
            this.put(putData).success(function(data){
                callback();
            });
        }
    }
});